<template>
	<div id="app">
		<main ref="main">
			<router-view/>
		</main>
	</div>
</template>

<script>
//indexから移設
var windowW = window.parent.screen.width;
var ua = navigator.userAgent;
document.open();
if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || (ua.indexOf('Android') > 0) && (ua.indexOf('Mobile') >
    0) || ua.indexOf('Windows Phone') > 0 || windowW <= 750) {
  document.write('<meta name="viewport" content="width=device-width" class="a">');
} else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
  document.write('<meta content="width=1200" name="viewport" class="b">');
} else {
  document.write('<meta content="width=1200" name="viewport" class="c">');
}
document.close();

//methods
import Util from '@/assets/script/Util'

import { mapMutations } from 'vuex'

export default {
	name: 'App',

	data() {
		return {
			data_path: './data/shop_dt.xlsx',//店舗データ
			prefectures_path: './data/prefectures_mt.xlsx',//都道府県マスタ
			municipality_path: './data/municipality_mt.xlsx',//市区町村マスタ

			config_data_is_loaded: false
		}
	},

	async created() {
		const await_list = [
			Util.loadXlsx(this.data_path),
			Util.loadXlsx(this.prefectures_path),
			Util.loadXlsx(this.municipality_path)
		];
		const [excel_data, prefectures_data, municipality_data] = await Promise.all(await_list);
		this.setExcelData(excel_data);
		this.setPrefecturesData(prefectures_data);
		this.setMunicipalityData(municipality_data);


		this.config_data_is_loaded = true;
	},

	methods: {
		...mapMutations(['setExcelData', 'setPrefecturesData', 'setMunicipalityData'])
	}
}
</script>

<style>
.buttons{
	width: 280px;
	height: 32px;
	margin: 0 auto;
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: bold;
	color:  var(--toso_base_black);
	background-color: #E3E3E3;
	cursor: pointer;
	transition: .3s;
}
.buttons:hover{
	color: white;
	background-color: var(--toso_base_green);
}
</style>
